<template>
  <div style="padding: 24px">
    <el-card shadow="never" style="border-radius: 8px">
      <!-- 搜索操作栏 -->
      <div style="margin-bottom: 24px; color: #4e5969">
        <el-row type="flex" justify="space-between" align="middle">
          <!-- 左侧：搜索与筛选 -->
          <div style="display: flex; gap: 12px; align-items: center">
            <el-input
              v-model="query.keyword"
              placeholder="关键词搜索"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
            />
            <el-select
              v-model="query.rule_status"
              placeholder="策略开关"
              clearable
              style="width: 130px"
              @change="handleSearch"
            >
              <el-option label="全部" value="" />
              <el-option label="开启" value="1" />
              <el-option label="关闭" value="2" />
            </el-select>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              style="margin: 0px"
              @click="handleReset"
            >重置</el-button>
          </div>
          <!-- 右侧：新增 -->
          <div style="display: flex; gap: 12px">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="showAddDialog = true"
            >新增</el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="showAcountDialog = true"
            >账号管理</el-button>
          </div>
        </el-row>
      </div>

      <!-- 自定义骨架屏动画 -->
      <div v-if="loading" style="padding: 32px 0">
        <div v-for="n in query.page_size" :key="n" class="skeleton-row">
          <div v-for="k in 6" :key="k" class="skeleton-cell" />
        </div>
      </div>

      <!-- 表格（loading时隐藏） -->
      <el-table
        v-else
        :data="tableData"
        stripe
        border
        style="min-width: 1200px; border-radius: 8px"
        :header-cell-style="{ background: '#F5F7FA' }"
      >
        <el-table-column prop="yw_aid" label="阅文账户id" align="center" />
        <el-table-column prop="appid" label="AppId" align="center" />
        <!-- 产品详情合并列 -->
        <el-table-column label="产品详情" align="center" min-width="280">
          <template slot-scope="scope">
            <div
              class="prod-detail-cell copyable"
              :title="'点击复制：' + detailText(scope.row)"
              @click="copyDetail(scope.row)"
            >
              <span class="miniapp-tag">
                <i class="el-icon-chat-dot-round" style="margin-right: 3px" />
                {{ scope.row.miniapp_name || '-' }}
              </span>
              <span class="prod-detail-text">
                {{ scope.row.prod_name || '-'
                }}<span
                  v-if="scope.row.auth_name"
                >·{{ scope.row.auth_name }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="config_status" label="回传开关" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.config_status"
              :active-value="1"
              :inactive-value="0"
              @change="kaione(scope.row.id)"
            />
          </template>
        </el-table-column>

        <el-table-column prop="rule_status" label="策略开关" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.rule_status"
              :active-value="1"
              :inactive-value="0"
              @change="kaitwo(scope.row.id)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="open_time" label="开启时间(分钟)" align="center">
          <template slot-scope="scope">
            <span
              style="cursor: pointer; color: #165dff"
              title="点击修改"
              @click="openTimeDialog(scope.row)"
            >
              {{ scope.row.open_time || 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="close_time" label="关闭时间(分钟)" align="center">
          <template slot-scope="scope">
            <span
              style="cursor: pointer; color: #165dff"
              title="点击修改"
              @click="openTimeDialog(scope.row)"
            >
              {{ scope.row.close_time || 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="执行时间">
          <template slot-scope="scope">
            <el-tooltip
              placement="right"
              effect="light"
              :disabled="!scope.row.last_execute_at || scope.row.last_execute_at.length <= 1"
            >
              <el-tag>
                {{ scope.row.last_execute_at && scope.row.last_execute_at[0] ? scope.row.last_execute_at[0] : '无数据' }}
              </el-tag>
              <template #content>
                <div v-if="scope.row.last_execute_at && scope.row.last_execute_at.length">
                  <div v-for="(item, index) in scope.row.last_execute_at" :key="index">
                    {{ item }}
                  </div>
                </div>
                <span v-else>无执行记录</span>
              </template>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <div
              style="cursor: pointer; color: #ff4949"
              @click="handleDelete(scope.row)"
            >
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div style="margin-top: 16px; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="total"
          :page-size="query.page_size"
          :current-page.sync="query.page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增监控"
      :visible.sync="showAddDialog"
      width="600px"
      @open="handleAddDialogOpen"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        label-width="130px"
        style="padding-top: 12px"
      >
        <el-form-item label="账号" prop="yw_aid">
          <el-select
            v-model="addForm.yw_aid"
            placeholder="请选择账号"
            filterable
            remote
            :remote-method="getAccountList"
            style="width: 100%"
            @change="handleAccountChange"
          >
            <el-option
              v-for="item in account_list"
              :key="item.id"
              :label="item.account"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="业务" prop="coopid">
          <el-select
            v-model="addForm.coopid"
            filterable
            placeholder="请选择业务"
            style="width: 100%"
            :disabled="!addForm.yw_aid"
            @change="handleCoopChange"
          >
            <el-option
              v-for="item in coopList"
              :key="item.coopid"
              :label="item.name"
              :value="item.coopid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="appid">
          <el-select
            v-model="addForm.appid"
            filterable
            placeholder="请选择产品"
            :disabled="!addForm.coopid"
            style="width: 100%"
          >
            <el-option
              v-for="item in appList"
              :key="item.appid"
              :label="item.prod_name"
              :value="item.appid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="小程序名称" prop="miniapp_name">
          <el-input
            v-model="addForm.miniapp_name"
            placeholder="请输入小程序名称"
          />
        </el-form-item>
        <el-form-item label="小程序类型" prop="auth_name">
          <el-input
            v-model="addForm.auth_name"
            placeholder="请输入小程序类型"
          />
        </el-form-item>
        <el-form-item label="公众号名称" prop="prod_name">
          <el-input
            v-model="addForm.prod_name"
            placeholder="请输入公众号名称"
          />
        </el-form-item>
        <el-form-item label="回传开关" prop="config_status">
          <el-radio-group v-model="addForm.config_status">
            <el-radio-button :label="1">开启</el-radio-button>
            <el-radio-button :label="2">关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开启时间(分钟)" prop="open_time">
          <el-input-number
            v-model="addForm.open_time"
            :min="1"
            style="width: 120px"
          />
        </el-form-item>
        <el-form-item label="关闭时间(分钟)" prop="close_time">
          <el-input-number
            v-model="addForm.close_time"
            :min="1"
            style="width: 120px"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改时间"
      :visible.sync="showTimeDialog"
      width="400px"
    >
      <el-form :model="timeEditForm" label-width="120px">
        <el-form-item label="开启时间(分钟)">
          <el-input-number
            v-model="timeEditForm.open_time"
            :min="1"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="关闭时间(分钟)">
          <el-input-number
            v-model="timeEditForm.close_time"
            :min="1"
            style="width: 200px"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTimeDialog = false">取消</el-button>
        <el-button type="primary" @click="submitTimeEdit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="阅文账号"
      :visible.sync="showAcountDialog"
      @open="handleYueWenAccount"
    >
      <div style="margin-bottom: 20px;display: flex;justify-content: space-between">
        <div>
          <el-input v-model="yuewen_query.keyword" style="width: 200px" placeholder="请输入内容" />
          <el-select v-model="yuewen_query.status" style="margin: 0 5px">
            <el-option
              v-for="item in account_optins"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button type="primary" @click="handleYueWenAccount">查询</el-button>
        </div>
        <el-button type="success" icon="el-icon-add" @click="adddawe">新增</el-button>
      </div>
      <el-table
        :data="yuewen_table.list"
      >
        <el-table-column prop="id" label="id" />
        <el-table-column prop="account" label="账号" />
        <el-table-column prop="status_text" label="在线状态">
          <template scope="scope">
            <el-tag :type="scope.row.status === 2 ? 'success' : scope.row.status === 1? 'info' : 'danger'">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template scope="scope">
            <el-button v-if="scope.row.status !== 2" type="primary" size="mini" @click="loginYueWen(scope.row)">登录</el-button>
            <el-button type="warning" size="mini" @click="logieditr(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deteir(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination-right
        :current-page="yuewen_query.page"
        :total="yuewen_table.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        title="新增账号"
        :visible.sync="add_account_dialog"
        :close-on-click-modal="false"
        width="500px"
        append-to-body
      >
        <el-form ref="addYuewenFormRef" label-width="80px" :rules="add_yuewen_rule" :model="add_yuewen_form">
          <el-form-item label="账号" prop="account">
            <el-input v-model="add_yuewen_form.account" property="请输入账号" style="width: 350px" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="add_yuewen_form.password" property="请输入密码" style="width: 350px" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="add_yuewen_form.remark" property="请输入备注" style="width: 350px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="add_account_dialog = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  yuewenList,
  yuewenDel,
  yuewenAdd,
  getCoops,
  getApp,
  switchstrategy,
  switchconfig,
  setTime, getYueWenAccountList, addYueWenAccount, loginYueWen, yuewenEdit, yuewendestroy
} from '../../api/yuewenMonitor.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  name: 'YuewenMonitor',
  components: { PaginationRight },
  data() {
    return {
      // 查询参数
      query: {
        keyword: '',
        rule_status: '',
        page: 1,
        page_size: 10
      },
      // 列表数据
      tableData: [],
      // 总条数
      total: 0,
      // 加载状态
      loading: false,
      // 新增弹窗显隐
      showAddDialog: false,
      showAcountDialog: false,
      add_account_dialog: false,
      add_yuewen_form: {
        account: null,
        password: null,
        remark: null
      },
      yuewen_table: {
        list: [],
        total: 0
      },
      yuewen_query: {
        page: 1,
        page_size: 10,
        keyword: null,
        status: '0'
      },
      account_optins: [
        { label: '全部', value: '0' },
        { label: '离线', value: '1' },
        { label: '在线', value: '2' },
        { label: '异常', value: '3' }
      ],
      // 新增表单数据
      addForm: {
        yw_aid: undefined,
        coopid: undefined,
        appid: undefined,
        miniapp_name: '',
        auth_name: '',
        prod_name: '',
        config_status: 1,
        open_time: 1,
        close_time: 1
      },
      addFormRules: {
        yw_aid: [{ required: true, message: '请选择账号', trigger: 'change' }],
        coopid: [{ required: true, message: '请选择业务', trigger: 'change' }],
        appid: [{ required: true, message: '请选择产品', trigger: 'change' }],
        miniapp_name: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        auth_name: [
          { required: true, message: '请输入小程序类型', trigger: 'blur' }
        ],
        prod_name: [
          { required: true, message: '请输入公众号名称', trigger: 'blur' }
        ],
        config_status: [
          { required: true, message: '请选择回传开关', trigger: 'change' }
        ],
        open_time: [
          {
            required: true,
            type: 'number',
            message: '请输入开启时间',
            trigger: 'blur'
          }
        ],
        close_time: [
          {
            required: true,
            type: 'number',
            message: '请输入关闭时间',
            trigger: 'blur'
          }
        ]
      },
      add_yuewen_rule: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      account_list: [],
      coopList: [],
      appList: [],
      showTimeDialog: false,
      timeEditRow: null, // 当前要编辑的行对象
      timeEditForm: {
        open_time: 1,
        close_time: 1
      },
      alltype: null,
      ids: null
    }
  },
  watch: {
    'addForm.appid'(newAppid) {
      const selected = this.appList.find((item) => item.appid === newAppid)
      if (selected) {
        this.addForm.miniapp_name = selected.miniapp_name || ''
        this.addForm.auth_name = selected.auth_name || ''
        this.addForm.prod_name = selected.prod_name || ''
      } else {
        this.addForm.miniapp_name = ''
        this.addForm.auth_name = ''
        this.addForm.prod_name = ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await yuewenList({ ...this.query })
        if (res && res.success) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取数据失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('请求失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.query.page = 1
      this.getList()
    },
    handleReset() {
      this.query.keyword = ''
      this.query.rule_status = ''
      this.query.page = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.query.page_size = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.query.page = page
      this.getList()
    },
    handleDelete(row) {
      this.$confirm(`确定删除【${row.prod_name}】吗？`, '提示', {
        type: 'warning'
      })
        .then(async() => {
          try {
            const res = await yuewenDel({ id: row.id })
            if (res && res.success) {
              this.$message.success('删除成功')
              this.getList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (err) {
            console.error(err)
            this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          /* 用户取消 */
        })
    },
    // 新增弹窗打开时加载业务
    async handleAddDialogOpen() {
      this.resetAddForm()
      this.getAccountList('')
    },
    // 业务变化时加载产品
    async handleCoopChange(coopid) {
      this.addForm.appid = undefined
      this.appList = []
      if (!coopid) return
      try {
        const res = await getApp({ coopid: coopid, yw_aid: this.addForm.yw_aid })
        if (res && res.success) {
          this.appList = res.data || []
        }
      } catch (e) {
        this.$message.error('获取产品列表失败')
      }
    },
    getAccountList(val) {
      getYueWenAccountList({ page: 1, page_size: 10, keyword: val }).then((res) => {
        this.account_list = res.data.list
      })
    },
    // 账号变化时加载业务
    async handleAccountChange() {
      try {
        const res = await getCoops({ yw_aid: this.addForm.yw_aid })
        if (res && res.success) {
          let arr = []
          if (res.data) {
            arr = Array.isArray(res.data) ? res.data : [res.data]
          }
          this.coopList = arr
        }
      } catch (e) {
        this.$message.error('获取业务列表失败')
      }
    },
    // 提交新增
    submitAdd() {
      this.$refs.addFormRef.validate(async(valid) => {
        if (!valid) return
        try {
          const req = { ...this.addForm }
          const res = await yuewenAdd(req)
          if (res && res.success) {
            this.$message.success('新增成功！')
            this.showAddDialog = false
            this.getList()
          } else {
            this.$message.error(res.message || '新增失败')
          }
        } catch (e) {
          this.$message.error('新增失败，请重试')
        }
      })
    },
    // 新增表单重置
    resetAddForm() {
      this.addForm = {
        yw_aid: undefined,
        coopid: undefined,
        appid: undefined,
        miniapp_name: '',
        auth_name: '',
        prod_name: '',
        config_status: 1,
        open_time: 1,
        close_time: 1
      }
      this.appList = []
      if (this.$refs.addFormRef) this.$refs.addFormRef.resetFields()
    },
    // 表格详情复制
    detailText(row) {
      // 复制内容格式：小程序名称·产品名称·作者名称
      const arr = [row.miniapp_name, row.prod_name, row.auth_name].filter(
        Boolean
      )
      return arr.join('·') || '-'
    },
    copyDetail(row) {
      const text = this.detailText(row)
      if (!text || text === '-') {
        this.$message.warning('暂无可复制内容')
        return
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message.success('已复制：' + text)
          },
          () => {
            this.$message.error('复制失败，请手动复制')
          }
        )
      } else {
        // 兼容性处理
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('已复制：' + text)
      }
    },
    kaione(id) {
      switchconfig({
        id: id
      }).then((res) => {
        this.getList()
        this.$message.success('修改成功')
      })
    },
    kaitwo(id) {
      switchstrategy({
        id: id
      }).then((res) => {
        this.getList()
        this.$message.success('修改成功')
      })
    },
    openTimeDialog(row) {
      this.timeEditRow = row
      this.timeEditForm = {
        open_time: row.open_time || 1,
        close_time: row.close_time || 1
      }
      this.showTimeDialog = true
    },
    async submitTimeEdit() {
      const id = this.timeEditRow.id
      const { open_time, close_time } = this.timeEditForm
      if (!id || !open_time || !close_time) {
        this.$message.error('参数错误')
        return
      }
      try {
        this.$message.info('正在提交...')
        // 调用接口
        const res = await setTime({ id, open_time, close_time })
        if (res.success) {
          this.$message.success('修改成功！')
          this.showTimeDialog = false
          this.getList()
        } else {
          this.$message.error(res.data?.message || res.message || '修改失败')
        }
      } catch (e) {
        this.$message.error('请求失败，请稍后重试')
      }
    },
    handleYueWenAccount() {
      getYueWenAccountList(this.yuewen_query).then((res) => {
        console.log(res)
        this.yuewen_table = res.data
      })
    },
    fetchPageSize(e) {
      this.yuewen_query.page_size = e
      this.handleYueWenAccount()
    },
    fetchCurrentPage(e) {
      this.yuewen_query.page = e
      this.handleYueWenAccount()
    },
    submitForm() {
      this.$refs.addYuewenFormRef.validate(valid => {
        if (valid) {
          // eslint-disable-next-line eqeqeq
          if (this.alltype == 1) {
            addYueWenAccount(this.add_yuewen_form).then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('提交成功！')
                this.handleYueWenAccount()
                this.add_account_dialog = false
              }
            })
          // 提交逻辑写这里
          } else {
            yuewenEdit({ ...this.add_yuewen_form, id: this.ids }).then((res) => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('提交成功！')
                this.handleYueWenAccount()
                this.add_account_dialog = false
              }
            })
          }
        } else {
          this.$message.error('请完善账号和密码')
          return false
        }
      })
    },
    loginYueWen(val) {
      console.log(val.id)
      loginYueWen({ id: val.id }).then((res) => {
        if (res.code === 0) {
          this.$message.success('请求成功')
        }
      })
    },
    adddawe() {
      this.add_yuewen_form = {
        account: null,
        password: null,
        remark: null
      }
      this.add_account_dialog = true
      this.alltype = 1
    },
    logieditr(item) {
      console.log('item', item)
      this.add_account_dialog = true
      this.alltype = 2
      this.ids = item.id
      this.add_yuewen_form.account = item.account
      this.add_yuewen_form.password = ''
      this.add_yuewen_form.remark = item.remark
    },
    deteir(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await yuewendestroy({ id: id })
        this.handleYueWenAccount()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    }
  }
}
</script>

<style scoped>
.skeleton-row {
  display: flex;
  margin-bottom: 18px;
}
.skeleton-cell {
  flex: 1;
  height: 32px;
  margin-right: 12px;
  background: linear-gradient(90deg, #f4f4f5 25%, #e9ecef 37%, #f4f4f5 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: skeleton-loading 1.2s ease-in-out infinite;
}
.skeleton-cell:last-child {
  margin-right: 0;
}
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.prod-detail-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;
}
.prod-detail-cell:hover {
  background: #f5f7fa;
  border-radius: 6px;
}
.copyable:active {
  opacity: 0.8;
}
.miniapp-tag {
  display: flex;
  align-items: center;
  padding: 0 8px;
  background: #165dff14;
  color: #165dff;
  border-radius: 5px;
  height: 25px;
  line-height: 25px;
  margin-right: 2px;
}
.prod-detail-text {
  color: #262626;
  white-space: nowrap;
}
.el-radio-button__inner {
  padding: 0 24px;
}
</style>
